import { Size2MixExpandCollapseBar, Size2MixSection, Size2MixSimpleTable, Size2MixStatusTag, useSectionsToggle } from '@shared/size2mix-shell';
import type { OptimisationDetail } from './types';

const SECTIONS = ['slacks', 'errors'] as const;

export default function LogsTab({ detail }: { detail: OptimisationDetail }) {
    const { bind, expandAll, collapseAll } = useSectionsToggle(SECTIONS);
    const details = detail.logs.errors.flatMap((error) => error.details.map((item) => ({ level: error.level, message: error.message, ...item })));
    return (
        <>
            <Size2MixExpandCollapseBar onExpandAll={expandAll} onCollapseAll={collapseAll} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <Size2MixSection title="Slacks" icon="warning" togglePosition="trailing" {...bind('slacks')}>
                    <Size2MixSimpleTable columns={[{ key: 'name', label: 'Nom' }, { key: 'value', label: 'Valeur' }]} rows={detail.logs.slacks} emptyLabel="No data available" />
                </Size2MixSection>
                <Size2MixSection title="Erreurs" icon="error" togglePosition="trailing" {...bind('errors')}>
                    <p style={{ fontSize: 14, margin: '0 0 16px' }}>Résumé</p>
                    <Size2MixSimpleTable
                        columns={[
                            { key: 'level', label: 'Niveau', width: 150, render: (row) => <Size2MixStatusTag label={row.level} size="lg" /> },
                            { key: 'message', label: 'Erreur' },
                            { key: 'count', label: 'Nombre', width: 150 },
                        ]}
                        rows={detail.logs.errors}
                        pageSize={15}
                    />
                    <p style={{ fontSize: 14, margin: '24px 0 16px' }}>Détails</p>
                    <Size2MixSimpleTable
                        columns={[
                            { key: 'level', label: 'Niveau', width: 150, render: (row) => <Size2MixStatusTag label={row.level} size="lg" /> },
                            { key: 'message', label: 'Erreur' },
                            { key: 'object', label: 'Objet', width: 150 },
                            { key: 'value', label: 'Valeur', width: 150 },
                        ]}
                        rows={details}
                        pageSize={15}
                    />
                </Size2MixSection>
            </div>
        </>
    );
}
